export default "__VITE_ASSET__DuD6r3fF__"